<template>
  <div class="project-user-list page-box">
    <div class="page-content">
      <div class="content-header">
        <div class="m-input-outer">
          <el-input
            class="search-input box-item"
            style="width: 100%"
            v-model="name"
            placeholder="公众号名称"
            clearable
          ></el-input>
        </div>
        <el-input
          class="search-input box-item hidden-xs-only"
          v-model="name"
          placeholder="公众号名称"
          clearable
        ></el-input>
        <vs-button
          type="info"
          class="search-btn btn box-item"
          @click="searchHandle"
        >查询</vs-button>
        <vs-button
          v-if="isAuth('wx:wxaccount:save')"
          class="add-btn btn box-item"
          @click="addHandle"
        >新增</vs-button>
        <vs-button
          v-if="isAuth('wx:wxaccount:delete')"
          :disabled="selected.length < 1"
          class="mutil-btn"
          @click="deleteHandle()"
        >批量删除</vs-button>
      </div>
      <div class="vs-table-outer">
        <vs-table
          multiple
          v-model="selected"
          :data="listData"
        >
          <template
            slot="thead">
            <vs-th>
              APPID
            </vs-th>
            <vs-th>
              公众号名称
            </vs-th>
            <vs-th>
              绑定域名
            </vs-th>
            <vs-th>
              类型
            </vs-th>
            <vs-th>
              是否认证
            </vs-th>
            <vs-th>
              操作
            </vs-th>
          </template>
          <template slot-scope="{data}">
            <vs-tr
              v-for="(tr, index) in data"
              :key="index"
              :data="tr"
            >
              <vs-td>
                {{tr.appid}}
              </vs-td>
              <vs-td>
                {{tr.name}}
              </vs-td>
              <vs-td>
                {{tr.articleDomain}}
              </vs-td>
              <vs-td>
                {{getType(tr.type)}}
              </vs-td>
              <vs-td>
                <span
                  class="self-tag"
                  :style="getStatusStyle(tr)"
                >
                  {{tr.verified ? '是': '否'}}
                </span>
              </vs-td>
              <vs-td>

                <el-button
                  type="text"
                  @click="accessHandle(tr)"
                >接入</el-button>
                <el-button
                  v-if="isAuth('wx:wxaccount:update')"
                  type="text"
                  @click.stop="editHandle(tr)"
                >修改</el-button>
                <el-button
                  v-if="isAuth('wx:wxaccount:delete')"
                  class="delete-btn"
                  type="text"
                  @click="deleteHandle(tr.appid)"
                >删除</el-button>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
    </div>
    <add-dialog
      :dialog-show="addDialogShow"
      @close="closeAddDialog"
      @add-success="addUserSuccess"
    ></add-dialog>
    <edit-dialog
      :row-data="currentRow"
      :dialog-show="editDialogShow"
      @close="closeEditDialog"
      @add-success="editUserSuccess"
    ></edit-dialog>
    <info-dialog
      :dialog-show="infoDialogShow"
      :account="currentRow"
      @close="infoDialogShow = false"
    ></info-dialog>
  </div>
</template>

<script>
import infoDialog from '@/components/wx/wx-account/infoDialog'
import editDialog from '@/components/wx/wx-account/editDialog'
import addDialog from "@/components/wx/wx-account/addDialog";
import { mapGetters } from 'vuex'
import { colorRgba,parseTime } from '@/utils/index'
import initData from "@/mixins/initData";
import { deteleAccount } from "@/api/wx/account";
export default {
  name: "index",
  components: {
    addDialog,
    editDialog,
    infoDialog,
  },
  data() {
    return {
      name: '',
      selected: [],
      red: '#D85E5F',
      green: '#41B883',
      addDialogShow: false,
      editDialogShow: false,
      currentRoleId: 0,
      currentRow: {},
      infoDialogShow: false,
    }
  },
  mixins: [initData],
  computed: {
    ...mapGetters(['themeColor','userInfo']),
  },
  created(){
    this.getData();
  },
  methods: {
    parseTime,
    getData(){
      let url = '/wx/manage/wxAccount/list';
      let params = {
        page: 1,
        limit: 100,
      }

      if(this.name){
        params.name = this.name;
      }
      this.$http({
        url: url,
        methods: 'get',
        params: params
      }).then((res) => {
        console.log(res);
        this.listData = res.page.list;
        if(this.selected){
          this.selected.length = 0;
          document.querySelector(".vs-table-outer .vs-con-table").__vue__.$emit('input', []);
        }
      }).catch((error) => {
        console.log(error);
      })
    },
    getType(type){
      switch (type){
        case 1:
          return '订阅号';
        case 2:
          return '服务号';
      }
    },
    getStatusStyle(tr){
      if(!tr.verified){
        return {
          backgroundColor: colorRgba(this.red ,0.1),
          color: this.red,
        };
      }else {

        return {
          backgroundColor: colorRgba(this.green,0.1),
          color: this.green,
        };
      }
    },
    addHandle(){
      setTimeout(() => {
        this.addDialogShow = true;
      },200);
    },
    addUserSuccess(){
      this.addDialogShow = false;
      this.searchHandle();
    },
    accessHandle(tr){
      this.currentRow = tr;
      this.infoDialogShow = true;
    },

    editHandle(row){
      this.currentRow = row;
      this.editDialogShow = true;
    },
    editUserSuccess(){
      this.editDialogShow = false;
      this.searchHandle();
    },
    closeEditDialog(){
      this.currentRow = {};
      this.editDialogShow = false;
    },
    deleteHandle(id){
      let ids = id ? [id] : this.selected.map(item => item.appid);
      this.$confirm(`确定对[id=${ids.join(',')}]进行[${id ? '删除' : '批量删除'}]操作?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deteleAccount(ids).then((res) => {
          this.$message({
            type: 'success',
            message: '已删除'
          });
          this.searchHandle();
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    closeAddDialog(){
      this.addDialogShow = false;
    },
    getStatus(tr){
      if(tr.status === 0){
        return '禁用';
      }else {
        return '正常';
      }
    },
    getStyle(tr){
      if(tr.status === 0){
        return {
          backgroundColor: colorRgba(this.red ,0.1),
          color: this.red,
        };
      }else {

        return {
          backgroundColor: colorRgba(this.green,0.1),
          color: this.green,
        };
      }
    },
    searchHandle(){

      this.getData();
    },
  },
}
</script>

<style lang="scss" scoped>
.project-user-list {
  .box-item {
    margin-bottom: 10px;
  }
  .btn {
    margin-right: 10px;
  }
  .vs-table-outer {
    .vs-con-table {
      min-width: 1200px;
    }
  }
  .tag-box {
    padding: 5px 10px;
    border-radius: 15px;
  }
  .reject-reason {
    max-width: 120px;
  }
}
</style>
